export const UserOperations = {
    LOAD_USERS: "LOAD_USERS"
}